export enum FAVORITES_VARIANT {
    NORMAL = 'normal',
    OUTLINED = 'outlined'
}
